<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Driver Bid Manager Board</span><br/>
      <div style="font-style: italic; font-size: 18px; padding-bottom: 15px; margin-right: 10px">
        shows active bid details, click + for more details
        <span style="float:right;">
            <b-button variant="info" size="sm" @click="showColorInfo = !showColorInfo"><b>info</b></b-button>
          </span>
      </div>
    </div>
    
    <div style="font-size: 22px; font-weight: bold; margin-top: 20px; position: relative" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
      <b-button v-on:click.prevent="load_data()" :disabled="loading">Get Results</b-button> 
      <span v-if="(base_options && base_options.length > 2) && !is_driver_role()">
        &nbsp;&nbsp;<b-form-select v-model="selected_base" :options="base_options" style="font-size: 18px; font-weight: bold; width:200px"/>
      </span>
      &nbsp;&nbsp;<b-form-checkbox v-model="hideNoBids" style="font-size: 16px;">Hide drivers without bids</b-form-checkbox>
      <!-- <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a> -->
    </div>
    <div v-if="bid_due_warning" class="align-right d-flex align-items-center justify-content-center" style="margin-top: 15px; font-size: 20px; font-weight: bold;">
        {{ bid_due_warning }} by 11am EST on {{ bid_due_Date }}
    </div>

    <div v-if="!loading">
      <div class="row" style="margin:30px; font-weight: bold; font-size: 24px;">
        <div class="col" style="padding:5px; border: 1px solid grey;">{{items.length}} bookings &middot; {{filteredDriverCount}} drivers</div>
        <div class="col" style="padding:5px"><b-button v-on:click.prevent="load_data()">Reload</b-button></div>
      </div>
      <div class="bid-color-key" style="margin: 0 30px 10px; display: flex; flex-wrap: wrap; align-items: center; gap: 14px; font-size: 13px;">
        <span style="font-weight: bold;">Key:</span>
        <span class="key-item"><span class="key-swatch" style="background:#e6ffed;"></span> Bid Placed</span>
        <span class="key-item"><span class="key-swatch" style="background:#9ac2ff;"></span> WON / REQ</span>
        <span class="key-item"><span class="key-swatch" style="background:#c9a227;"></span> Other Award (OBD, OBR, HOS, NEB)</span>
      </div>
    </div>
    <b-modal v-model="showColorInfo" title="Row Colors & Bid Awards" size="lg" hide-footer>
      <div class="mb-3">
        <h6>Row colors</h6>
        <div style="display:flex; align-items:center; margin-bottom:6px;">
          <div style="width:20px; height:16px; background:#ffffff; border:1px solid #ccc; margin-right:8px;"></div>
          <span>Normal row (no bid, not cancelled)</span>
        </div>
        <div style="display:flex; align-items:center; margin-bottom:6px;">
          <div style="width:20px; height:16px; background:#f2f2f2; border:1px solid #ccc; margin-right:8px;"></div>
          <span>Alternate row shading</span>
        </div>
        <div style="display:flex; align-items:center; margin-bottom:6px;">
          <div style="width:20px; height:16px; background:#e6ffed; border:1px solid #ccc; margin-right:8px;"></div>
          <span>Has a bid for this trip</span>
        </div>
        <div style="display:flex; align-items:center; margin-bottom:6px;">
          <div style="width:20px; height:16px; background:#ffecec; border:1px solid #ccc; margin-right:8px;"></div>
          <span>Booking is cancelled</span>
        </div>
        <div style="display:flex; align-items:center; margin-bottom:6px;">
          <div style="width:20px; height:16px; background:#9ac2ff; border:1px solid #ccc; margin-right:8px;"></div>
          <span>Bid award is WON or REQ</span>
        </div>
        <div style="display:flex; align-items:center;">
          <div style="width:20px; height:16px; background:#c9a227; border:1px solid #ccc; margin-right:8px;"></div>
          <span>Bid has another award status (not WON/REQ)</span>
        </div>
      </div>

      <div>
        <h6>Bid Awarded Options</h6>
        <ul style="padding-left:18px; margin-bottom:0;">
          <li><strong>WON</strong> – Bid was awarded</li>
          <li><strong>OBD</strong> – Outbid by a Driver with more Seniority</li>
          <li><strong>OBR</strong> – Outbid by a Driver Request</li>
          <li><strong>HOS</strong> – Bid was considered but HOS concerns prevented award</li>
          <li><strong>NEB</strong> – Not Eligible to bid</li>
          <li><strong>REQ</strong> – Awarded due to customer request</li>
        </ul>
      </div>
    </b-modal>
    <!-- <vue-html2pdf
        :enable-download="true"
        :manual-pagination="true"
        :filename="'daily-dispatch-board-' + details_fromDate"
        pdf-format="letter"
        margin="0px"
        pdf-orientation="landscape"
        pdf-content-width="1050px"
        ref="html2Pdf"
    >
      <section slot="pdf-content">
        <html>
          <template v-for="page in Array(Math.ceil(items.length / 25)).keys()">
          <br/>
            <table border="1" v-if="summary">
              <tr style="font-size: 10px">
                <th>Booking</th>
                <th>Organization</th>
                <th>Requested Driver</th>
                
                <th>Trip Ref</th>
                <th>Pickup Location</th>
                <th>Destination</th>
                <th>Driver</th>
                <th>Price</th>
                <th>Miles</th>
                <th>Veh Type</th>
                <th width="70px">Driver Start</th>
                <th width="70px">Base of Operation</th>
                <th width="70px">Departure</th>
                <th width="70px">Arrival</th>
                <th width="70px">Driver End</th>
              </tr>
              <template v-if="idx >= (page * 25) && idx < ((page+1)*25)" v-for="(item,idx) in items">
                <tr>
                  <td style="font-size: 12px">{{item.booking_id}}</td>
                  <td style="font-size: 10px">{{item.organization | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.requested_driver | trim(28)}}</td>
                  
                  <td style="font-size: 10px;">{{item.trip_reference | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.first_pickup_location | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.destination_location | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.driver}}</td>
                  <td style="font-size: 12px">{{item.price}}</td>
                  <td style="font-size: 12px">{{item.miles}}</td>
                  <td style="font-size: 10px">{{item.vehicle_type}}</td>
                  <td style="font-size: 12px">{{item.driver_start}}</td>
                  <td style="font-size: 12px">{{item.base_of_operation}}</td>
                  <td style="font-size: 12px">{{item.departure_time}}</td>
                  <td style="font-size: 12px">{{item.arrival_time}}</td>
                  <td style="font-size: 12px">{{item.driver_end}}</td>
                </tr>
              </template>
            </table>
            <br/>
            <table width="1000px">
              <tr>
                <td>Page {{page+1}} of {{Math.ceil(items.length/25)}}</td>
                <td align="right">{{current_date}}</td>
              </tr>
            </table>

            <div v-if="page+1 != Math.ceil(items.length/25)" class="html2pdf__page-break"/>

          </template>
        </html>
      </section>
    </vue-html2pdf> -->

    <div v-if="!loading">
      <div v-if="!driverRows.length" class="text-center text-muted" style="padding: 20px; font-size: 16px;">
        Loading drivers...
      </div>
      <div v-else class="driver-bid-table-wrapper">
        <table class="driver-bid-table">
          <thead>
            <tr class="main-header-row">
              <th class="col-seniority" style="cursor:pointer;" @click="sortBySeniority = !sortBySeniority">
                Seniority Rank {{ sortBySeniority ? '▼' : '▲' }}
              </th>
              <th class="col-operator">Operator</th>
              <th class="col-avail">Avail</th>
              <th v-for="n in 10" :key="'bh-' + n" class="col-bid-group">BID #{{ n }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(group, gIdx) in driverGroups">
              <tr :key="'sep-' + gIdx" class="group-separator-row">
                <td :colspan="13">{{ group.label }} ({{ group.rows.length }})</td>
              </tr>
              <template v-for="(driver, dIdx) in group.rows">
                <tr :key="'dr-' + gIdx + '-' + dIdx"
                    :class="['driver-row', dIdx % 2 === 0 ? 'row-even' : 'row-odd']"
                    @click="toggleDriverDetails(driver.tbn_driver_id)"
                    style="cursor: pointer;">
                  <td class="col-seniority">{{ driver.seniority_position != null ? driver.seniority_position : '-' }}</td>
                  <td class="col-operator">{{ driver.driver_name }}</td>
                  <td class="col-avail">{{ driver.driver_available === true ? 'AW' : (driver.driver_available === false ? 'O' : '') }}</td>
                  <td v-for="n in 10" :key="'c-id-' + gIdx + '-' + dIdx + '-' + n"
                      class="col-bid-val"
                      :class="driver.bids[n-1] ? getBidCellClass(driver.bids[n-1]) : 'empty-bid'">
                    {{ driver.bids[n-1] ? driver.bids[n-1].booking_id : '' }}
                  </td>
                </tr>
                <tr v-if="expandedDriverId === driver.tbn_driver_id" :key="'det-' + gIdx + '-' + dIdx">
                  <td :colspan="13" style="padding: 0;">
                    <div style="padding: 10px; background: #f9f9f9; border: 1px dotted grey; margin: 4px;">
                      <h6>{{ driver.driver_name }} - Bid Details</h6>
                      <b-table
                        v-if="driver.allBids && driver.allBids.length"
                        striped bordered small
                        :items="driver.allBids"
                        :fields="bidsFields"
                      >
                        <template slot="created_time" slot-scope="cell">
                          {{ formatBidCreatedTime(cell.value) }}
                        </template>
                        <template slot="approval" slot-scope="cell">
                          <b-form-select v-model="cell.item.approval" :options="approvalOptions" size="sm"/>
                        </template>
                        <template slot="action" slot-scope="cell">
                          <div style="display:flex; align-items:center; gap:6px;">
                            <b-button size="sm" @click="submitBid(cell.item)">Submit</b-button>
                            <span v-if="bidSubmitStatus[cell.item.dispatch_driver] === 'success'" style="color:green; font-weight:bold; font-size:12px;">&#10003; Saved</span>
                            <span v-if="bidSubmitStatus[cell.item.dispatch_driver] === 'failed'" style="color:red; font-weight:bold; font-size:12px;">&#10007; Failed</span>
                          </div>
                        </template>
                      </b-table>
                      <span v-else class="text-muted">No bids for this driver.</span>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else-if="loading">
      <div class="text-center text-danger my-2">
        <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>
        <!-- <template slot="row-details" slot-scope="row">
          <b-card style="background-color: white; text-align: left;">
            
            <b>Booking Details</b>
             
              <template slot="trip_reference" slot-scope="row">
                {{row.item.trip_reference }}
              </template>
              <template slot="organization" slot-scope="row">
                {{row.item.organization}}
              </template>
              <template slot="departure_time" slot-scope="row">
                {{row.item.departure_time }}
              </template>
              <template slot="arrival_time" slot-scope="row">
                {{row.item.arrival_time }}
              </template> -->
              <!-- <template slot="last_washed_time" slot-scope="row">
                {{row.item.last_washed_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_ready_time" slot-scope="row">
                {{row.item.last_ready_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_out_time" slot-scope="row">
                {{row.item.last_out_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_returned_time" slot-scope="row">
                {{row.item.last_returned_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="notes" slot-scope="row">
                <div style="margin:3px; text-align: left">{{row.item.notes}}</div>
              </template>
              <template slot="dump_date" slot-scope="row">
                {{row.item.dump_date | formatDateTimeCustom(summary.datetime_format)}}
              </template>

              <template slot="detailed_date" slot-scope="row">
                {{row.item.detailed_date | formatDateTimeCustom(summary.datetime_format)}}
              </template> -->

<script>

import {get_booking_bids_for_drivers_board, get_booking_bids_for_drivers_board_base, get_booking_bases, add_update_driver_bid, tbn_api_url, get_driver_bid_seniority_list, get_driver_unavailability} from "../networking/tbn_apis";
import {mapState} from "vuex";
import moment from 'moment';
import datetime from 'vuejs-datetimepicker';
import {justDate} from "../helpers/dates";
import axios from "axios";
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: 'driver_bid_manager_board_tbn',
  components: {
     datetime, VueHtml2pdf
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      search_filter: '',
      tenant_id: null,
      updating: false,
      reloading: false,
      current_date: moment().format('MMMM Do YYYY, h:mm:ss a'),
      details_fromDate: justDate(moment()),
      details_toDate: justDate(moment()),
      bid_due_Date: justDate(moment()),
      bid_due_warning: '',
      showColorInfo: false,
      items: [],
      items_full: [],
      summary: null,
      loading: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 300,
      pages: [],
      base_options: [],
      driver_options: [],
      selected_base: '',
      company_location: '',
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(30, 'days'),
        maxDate: moment().add(30, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },
      rows: [
        { id: 1, name: 'Alice', status: 'Active' },
        { id: 2, name: 'Bob', status: 'Inactive' }
      ],
      fields: [
        { key: 'details', label: '', sortable: false, thStyle: { width: '9px', maxWidth: '11px' }},
        { key: 'booking_id', sortable: true, visible: true, thStyle: { width: "80px" }},
        { key: 'dispatch_id', sortable: true, visible: true, thStyle: { width: "60px" }},
        //{ key: 'organization', sortable: true, visible: true, thStyle: { width: "180px" }},
        { key: 'requested_driver', sortable: true, visible: true, thStyle: { width: "100px" }},
        // { key: 'group_name', sortable: true, visible: true, thStyle: { width: "150px" }},
        //{ key: 'trip_reference', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'first_pickup_location', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'destination_location', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'driver_start', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'driver', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'price', sortable: true, visible: true, thStyle: { width: "60px" }},
        { key: 'miles', sortable: true, visible: true, thStyle: { width: "60px" }},
        { key: 'vehicle_type', sortable: true, visible: true,  thStyle: { width: "80px" }},
        //{ key: 'base_of_operation', sortable: true, visible: true, thStyle: { width: "200px" }},
        //{ key: 'departure_time', label: 'First Departure', sortable: true, visible: true},
        //{ key: 'arrival_time', label: 'Last Arrival', sortable: true, visible: true},
        //{ key: 'driver_end', sortable: true, visible: true, thStyle: { width: "200px" }}
      ],
      bidsFields: [
        { key: 'booking_id', label: 'Booking ID', sortable: true, thStyle: { width: '80px' }},
        { key: 'bid_order', label: 'Bid Order', sortable: true, thStyle: { width: '90px' }},
        { key: 'driver_name', label: 'Driver', sortable: true, thStyle: { width: '140px' }},
        { key: 'organization', label: 'Organization', sortable: true, thStyle: { width: '160px' }, formatter: value => (value || '').substring(0, 20) },
        // { key: 'booking_status', label: 'Status', sortable: true, thStyle: { width: '90px' }},
        { key: 'driver_ack', label: 'ACK', sortable: true, thStyle: { width: '90px' }},
        { key: 'driver_start', label: 'Job Start', sortable: true, thStyle: { width: '110px' }},
        { key: 'route_description', label: 'Route', sortable: true, thStyle: { width: '160px' }, formatter: value => (value || '') },
        { key: 'created_time', label: 'Created', sortable: true, thStyle: { width: '180px' }},
        // { key: 'driver_available', label: 'Available', sortable: true, thStyle: {width: '80px'}},
        { 
            key: 'driver_available', 
            label: 'Driver Avail', 
            formatter: value => value == true ? 'AW' : 'O', 
            thStyle: {width: '80px'}, 
            sortable: true 
        },
        { key: 'approval', label: 'Bid Award Status', sortable: false, thStyle: { width: '120px' }},
        { key: 'action', label: '', sortable: false, thStyle: { width: '80px' }}
      ],
      approvalOptions: [
        { value: '', text: 'Select...' },
        { value: 'WON', text: 'Bid was awarded' },
        { value: 'OBD', text: 'Outbid by a Driver with more Seniority' },
        { value: 'OBR', text: 'Outbid by a Driver Request' },
        { value: 'HOS', text: 'Bid was considered but HOS concerns prevented award' },
        { value: 'NEB', text: 'Not Eligible to bid' },
        { value: 'REQ', text: 'Awarded due to customer request' },
      ],
      bidsCurrentPage: 1,
      expandedDriverId: null,
      seniority_rank_map: {},
      sortBySeniority: true,
      bidSubmitStatus: {},
      hideNoBids: false,
      driver_unavailability: {},
    }
  },
  async created() {
    this.tenant_id = this.user.tenant
    this.fields_all = this.fields
    await this.setup_bases()
    this.setup_to_from_bid_dates()
    try {
      const senResp = await get_driver_bid_seniority_list(this.tenant_id)
      const { value: { data: senData = [] } } = senResp
      const map = {}
      ;(senData || []).forEach(u => {
        if (u.tbn_driver_id) {
          map[String(u.tbn_driver_id)] = {
            seniority_rank: parseFloat(u.seniority_rank) || 0,
            employment_status: u.employment_status || '',
            company_location: u.company_location || '',
            full_name: u.full_name || ''
          }
        }
      })
      this.seniority_rank_map = map
    } catch (e) {
      console.log('Error loading seniority data:', e)
      this.seniority_rank_map = {}
    }
    await this.check_features()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    get_emp_status(status) {
      if (status) {
        if (status.toLowerCase() == 'full') {
          return 'F'
        } else if (status.toLowerCase() == 'part') {
          return 'P'
        } else if (status.toLowerCase() == 'casual') {
          return 'C'
        }
      } else {
        return ''
      }
    },
    printPage() {
      this.$refs.html2Pdf.generatePdf()
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    showAlert(msg, variant, autoclose) {
      this.alert.show = true
      this.alert.message = msg
      this.alert.variant = variant
      autoclose
          ? setTimeout(() => this.closeAlert(), autoclose)
          : null
    },
    closeAlert() {
      this.alert.show = false
      this.alert.message = ''
      this.alert.variant = ''
    },
    async check_features() {
      this.fields = this.fields_all
      //this.load_data()
      this.driver_options = []
      this.company_location = this.user.company_location
      // try {
      //   const {value: {data = []}} = await get_driver_list(this.user.tenant)
      //   this.driver_options = data
      // } catch(e) {
      //   this.$emit('showAlert', 'error loading data, try logging in again or contact support if needed', 'danger', 5000)
      // }
    },
    get_row_color(item, type) {
      if (!item || type !== 'row') return
      if (item.cancelled) return 'rowred'
      const hasApprovalWonOrReq = (item.bids || []).some(
        (b) => b && (String(b.approval || '').toUpperCase() === 'WON' || String(b.approval || '').toUpperCase() === 'REQ')
      )
      if (hasApprovalWonOrReq) return 'rowblue'
      const hasOtherApproval = (item.bids || []).some((b) => {
        if (!b || !b.approval) return false
        const a = String(b.approval).toUpperCase()
        return a !== 'WON' && a !== 'REQ'
      })
      if (hasOtherApproval) return 'rowyellow'
      const hasBids = item.bids && item.bids.length
      if (hasBids) return 'rowgreen'
      if (item.row_id % 2 === 0) return 'rowgray'
      return 'rowgray-dark'
    },
    is_driver_role() {
      return this.user.role == 'driver'
    },
    toggleDriverDetails(driverId) {
      this.expandedDriverId = this.expandedDriverId === driverId ? null : driverId
    },
    getBidCellClass(bid) {
      if (!bid) return ''
      const approval = String(bid.approval || '').toUpperCase()
      if (approval === 'WON' || approval === 'REQ') return 'bid-won'
      if (approval && approval !== '') return 'bid-other-award'
      return 'bid-active'
    },
    expandAllRows() {
      (this.items || []).forEach((item) => {
        this.$set(item, '_showDetails', true)
      })
    },
    collapseAllRows() {
      (this.items || []).forEach((item) => {
        this.$set(item, '_showDetails', false)
      })
    },
    async load_data() {
      this.loading = true
      try {
        var results = null
        if (this.user.role == 'driver' && this.company_location && this.company_location != '') {
          results = await get_booking_bids_for_drivers_board_base(this.tenant_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), this.company_location,'',true)

        } else {
          results = await get_booking_bids_for_drivers_board(this.tenant_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),true)
        }
        // var results = await get_booking_bids_for_drivers_board(this.tenant_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        const {value: { data = [] } } = results

        try {
          const fromDateISO = moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD')
          const toDateISO = moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD')
          const unavailResp = await get_driver_unavailability(this.tenant_id, fromDateISO, toDateISO)
          const { value: { data: unavailData = {} } } = unavailResp
          this.driver_unavailability = unavailData
        } catch (e) {
          this.driver_unavailability = {}
        }

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        const resultsWithRowId = (data.results || []).map((it, idx) => ({ ...it, row_id: idx }))
        this.items = resultsWithRowId
        this.items_full = resultsWithRowId
        console.log('got results base options: ' + this.summary.base_options)
        this.base_options = (this.summary.base_options || []).filter(item => item.value.indexOf('Yard') == -1)
        if (this.selected_base != '') {
          this.items = this.items.filter(item => item.base_of_operation.indexOf(this.selected_base) != -1)
        }
        this.items = this.items.map((it, idx) => ({ ...it, row_id: idx }))

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    filter_results() {
      this.items = this.items_full
      if (!this.items)
        return
      if (this.selected_base != '') {
        this.items = this.items.filter(item => item.base_of_operation.indexOf(this.selected_base) != -1)
      }
      this.items = this.items.map((it, idx) => ({ ...it, row_id: idx }))
    },
    onChange(row) {
      console.log('Updated:', row)
    },
    async setup_bases() {
      try {
        var bases = null
        bases = await get_booking_bases(this.tenant_id)
        const { value: { data = [] } } = bases
        this.bases = data.summary
        console.log('NEW got results base options: ' + this.bases.base_options)
        this.base_options = this.bases.base_options
        this.base_options = this.base_options.filter(item => item.value.indexOf('Yard') == -1)

        if (this.selected_base != '') {
          this.items = this.items.filter(item => item.base_of_operation.indexOf(this.selected_base) != -1)
        }
      } catch (e) {
        console.log(e)
        this.$emit('showAlert', 'error retrieving bases, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    formatBidCreatedTime(isoStr) {
      if (!isoStr) return ''
      const m = moment(isoStr)
      return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : isoStr
    },
    getBookingRowAttr(item, type) {
      if (type !== 'row' || !item) return {}
      return {
        'data-booking-id': item.booking_id,
        'data-dispatch-id': item.dispatch_id
      }
    },
    goToBookingRow(bid) {
      if (!bid) return
      const bookingId = bid.booking_id != null ? String(bid.booking_id) : ''
      const dispatchId = bid.dispatch_id != null ? String(bid.dispatch_id) : ''
      const fullList = this.items || []
      const index = fullList.findIndex(
        (it) => String(it.booking_id || '') === bookingId && String(it.dispatch_id || '') === dispatchId
      )
      if (index === -1) return
      const item = fullList[index]
      const page = Math.floor(index / this.perPage) + 1
      if (this.currentPage !== page) this.currentPage = page
      this.$set(item, '_showDetails', true)
      const scrollAndFocus = () => {
        const root = this.$el
        if (!root) return
        const targets = root.querySelectorAll('.row-details-focus-target')
        let target = null
        for (let i = 0; i < targets.length; i++) {
          const t = targets[i]
          if (t.getAttribute('data-row-details-booking-id') === bookingId && t.getAttribute('data-row-details-dispatch-id') === dispatchId) {
            target = t
            break
          }
        }
        if (!target) return
        target.scrollIntoView({ behavior: 'smooth', block: 'center' })
        target.focus({ preventScroll: true })
      }
      this.$nextTick(() => {
        this.$nextTick(() => {
          setTimeout(scrollAndFocus, 150)
        })
      })
    },
    async saveDriverBid(bid_record) {
      const key = bid_record.dispatch_driver
      try {
        this.$emit('showAlert', 'waiting for response...', 'info')
        const { message, status_code } = await add_update_driver_bid(
          this.user.tenant,
          bid_record
        )
        this.$emit('showAlert', message || 'Success!', 'success', 1500)
        this.$set(this.bidSubmitStatus, key, 'success')
        setTimeout(() => { this.$set(this.bidSubmitStatus, key, null) }, 4000)
      } catch (e) {
        this.$emit(
          'showAlert',
          'error saving driver bid, contact support if needed',
          'danger',
          5000
        )
        this.$set(this.bidSubmitStatus, key, 'failed')
        setTimeout(() => { this.$set(this.bidSubmitStatus, key, null) }, 6000)
      }
    },
    async submitBid(bid, parentItem) {

      if (!bid.approval) {
        this.showAlert('Please select a reward status before submitting.', 'warning', 4000)
        return
      }
        //let bid_record = {}

        //console.log("bid: " + JSON.stringify(bid))
        //console.log("parentItem: " + JSON.stringify(parentItem))

        // row.username = this.user.username
        // row.employment_status = this.user.employment_status
        // row.tbn_driver_id = this.user.tbn_driver_id
        const excludedKeys = ['_showDetails']

        // bid_record = Object.fromEntries(
        //   Object.entries(bid.item).filter(([key]) => !excludedKeys.includes(key))
        // )
        // bid_record.username = this.user.username
        // bid_record.employment_status = this.user.employment_status
        // bid_record.tbn_driver_id = this.user.tbn_driver_id
        // bid_record.driver_name = this.user.full_name
        console.log('bid_record: ' + JSON.stringify(bid))
        this.saveDriverBid(bid)
    },
    findCityState(input) {
      //console.log('address: ' + input)
      if (!input) return null

      const text = input.replace(/\s+/g, ' ').trim()
      const STATES = [
        ['AL', 'Alabama'], ['AK', 'Alaska'], ['AZ', 'Arizona'], ['AR', 'Arkansas'],
        ['CA', 'California'], ['CO', 'Colorado'], ['CT', 'Connecticut'],
        ['DE', 'Delaware'], ['FL', 'Florida'], ['GA', 'Georgia'],
        ['HI', 'Hawaii'], ['ID', 'Idaho'], ['IL', 'Illinois'], ['IN', 'Indiana'],
        ['IA', 'Iowa'], ['KS', 'Kansas'], ['KY', 'Kentucky'], ['LA', 'Louisiana'],
        ['ME', 'Maine'], ['MD', 'Maryland'], ['MA', 'Massachusetts'],
        ['MI', 'Michigan'], ['MN', 'Minnesota'], ['MS', 'Mississippi'],
        ['MO', 'Missouri'], ['MT', 'Montana'], ['NE', 'Nebraska'],
        ['NV', 'Nevada'], ['NH', 'New Hampshire'], ['NJ', 'New Jersey'],
        ['NM', 'New Mexico'], ['NY', 'New York'], ['NC', 'North Carolina'],
        ['ND', 'North Dakota'], ['OH', 'Ohio'], ['OK', 'Oklahoma'],
        ['OR', 'Oregon'], ['PA', 'Pennsylvania'], ['RI', 'Rhode Island'],
        ['SC', 'South Carolina'], ['SD', 'South Dakota'], ['TN', 'Tennessee'],
        ['TX', 'Texas'], ['UT', 'Utah'], ['VT', 'Vermont'],
        ['VA', 'Virginia'], ['WA', 'Washington'], ['WV', 'West Virginia'],
        ['WI', 'Wisconsin'], ['WY', 'Wyoming'], ['DC', 'District of Columbia']
      ]

      // First try to parse addresses like:
      // "..., Washington, DC 20037, USA" -> "Washington, DC"
      const segments = text.split(',').map(s => s.trim()).filter(Boolean)
      if (segments.length >= 2) {
        for (let i = segments.length - 1; i >= 0; i--) {
          const seg = segments[i]
          // Look for a 2-letter state code at the start of a segment (e.g. "DC 20037")
          const abbrMatch = seg.match(/^([A-Za-z]{2})\b/)
          if (!abbrMatch) continue

          const stateAbbr = abbrMatch[1].toUpperCase()
          const stateExists = STATES.some(([abbr]) => abbr === stateAbbr)
          if (!stateExists) continue

          const citySegment = segments[i - 1]
          if (citySegment) {
            return citySegment + ', ' + stateAbbr
          }
        }
      }

      for (const [abbr, full] of STATES) {
        // Match "City, ST" or "City ST"
        const abbrRegex = new RegExp(
          `([A-Za-z .'-]+?),?\\s+${abbr}\\b`,
          'i'
        )

        const fullRegex = new RegExp(
          `([A-Za-z .'-]+?),?\\s+${full}\\b`,
          'i'
        )

        let match = text.match(abbrRegex) || text.match(fullRegex)

        if (match) {
          const city = match[1].trim()
          return city +', ' + abbr
          //return { city, state: abbr }
        }
      }
      return input
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${tbn_api_url}tbn/dispatch_board/download`,
          {
            tenant: this.tenant_id,
            date: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `dispatch-board-${this.user.tenant}-${this.details_fromDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
    setup_to_from_bid_dates() {
      console.log('setup_to_from_bid_dates'); 
      const today = new Date();
      const dayOfWeekNumber = today.getDay();

      // Example output: 3 (if today is Wednesday)
      if (dayOfWeekNumber == 4) {
        //console.log("it's thursday")
        this.details_fromDate = moment(justDate(moment()), 'MM-DD-YYYY').add(3, 'days').format('MM-DD-YYYY');
        this.details_toDate = moment(justDate(moment()), 'MM-DD-YYYY').add(4, 'days').format('MM-DD-YYYY');
        //this.bid_due_Date = moment(justDate(moment()), 'MM-DD-YYYY').add(4, 'days').format('MM-DD-YYYY');
        this.bid_due_warning = "Bids for Sunday and Monday are due "
      } else if (dayOfWeekNumber == 5) {
        //console.log("it's friday")
        this.details_fromDate = moment(justDate(moment()), 'MM-DD-YYYY').add(3, 'days').format('MM-DD-YYYY');
        this.details_toDate = moment(justDate(moment()), 'MM-DD-YYYY').add(4, 'days').format('MM-DD-YYYY');
        //this.bid_due_Date = moment(justDate(moment()), 'MM-DD-YYYY').add(4, 'days').format('MM-DD-YYYY');
        this.bid_due_warning = "Bids for Tuesday and Wednesday are due "
      } else {
        this.details_fromDate = moment(justDate(moment()), 'MM-DD-YYYY').add(3, 'days').format('MM-DD-YYYY');
        this.details_toDate = moment(justDate(moment()), 'MM-DD-YYYY').add(3, 'days').format('MM-DD-YYYY');
        //this.bid_due_Date = moment(justDate(moment()), 'MM-DD-YYYY').add(3, 'days').format('MM-DD-YYYY');
        if (dayOfWeekNumber == 3){
          this.bid_due_warning = "Bids for Saturday are due "
        } else if (dayOfWeekNumber == 2) {
          this.bid_due_warning = "Bids for Friday are due "
        } else if (dayOfWeekNumber == 1) {
          this.bid_due_warning = "Bids for Thursday are due "
        }
      }
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    bidsList() {
      const items = this.items || []
      const flattened = []

      items.forEach((booking) => {
        if (!booking) return
        const bids = booking.bids || []

        bids.forEach((bid) => {
          if (!bid) return
          flattened.push({
            ...bid,
            booking_id: bid.booking_id || booking.booking_id,
            dispatch_id: bid.dispatch_id || booking.dispatch_id,
          })
        })
      })

      return flattened
    },
    driverRows() {
      const rankMap = this.seniority_rank_map || {}
      // Build a set of unavailable driver IDs for the selected date(s)
      const unavailSets = {}
      Object.entries(this.driver_unavailability || {}).forEach(([date, ids]) => {
        unavailSets[date] = new Set(ids.map(String))
      })
      const selectedDateISO = moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD')
      const unavailForDate = unavailSets[selectedDateISO] || new Set()

      const bidsByDriverId = new Map()
      ;(this.items || []).forEach(booking => {
        if (!booking || !booking.bids) return
        booking.bids.forEach(bid => {
          if (!bid) return
          const driverId = String(bid.tbn_driver_id || '')
          if (!bidsByDriverId.has(driverId)) {
            bidsByDriverId.set(driverId, [])
          }
          bidsByDriverId.get(driverId).push({
            ...bid,
            booking_id: bid.booking_id || booking.booking_id,
            dispatch_id: bid.dispatch_id || booking.dispatch_id,
            organization: booking.organization || '',
          })
        })
      })

      const rows = []

      Object.keys(rankMap).forEach(driverId => {
        const driverInfo = rankMap[driverId]
        const driverBids = bidsByDriverId.get(driverId) || []
        const sorted = driverBids.slice().sort((a, b) => {
          return (parseInt(a.bid_order) || 999) - (parseInt(b.bid_order) || 999)
        })
        const firstBid = sorted[0] || {}
        const hasBid = sorted.length > 0
        const driverAvail = hasBid ? firstBid.driver_available : !unavailForDate.has(driverId)
        rows.push({
          driver_name: driverInfo.full_name || (firstBid.driver_name) || 'Unknown',
          tbn_driver_id: driverId,
          seniority_rank: driverInfo.seniority_rank || 0,
          employment_status: driverInfo.employment_status || '',
          company_location: driverInfo.company_location || '',
          driver_available: driverAvail,
          allBids: sorted,
          bids: sorted.slice(0, 10)
        })
        bidsByDriverId.delete(driverId)
      })

      bidsByDriverId.forEach((bids, driverId) => {
        const sorted = bids.slice().sort((a, b) => {
          return (parseInt(a.bid_order) || 999) - (parseInt(b.bid_order) || 999)
        })
        const name = (sorted[0] && sorted[0].driver_name) || 'Unknown'
        const driverInfo = rankMap[driverId] || {}
        const firstBid = sorted[0] || {}
        rows.push({
          driver_name: name,
          tbn_driver_id: driverId,
          seniority_rank: driverInfo.seniority_rank || 0,
          employment_status: driverInfo.employment_status || '',
          company_location: driverInfo.company_location || '',
          driver_available: firstBid.driver_available,
          allBids: sorted,
          bids: sorted.slice(0, 10)
        })
      })
      // note: drivers from bidsByDriverId always have a bid, so driver_available comes from the bid itself

      // Assign ordinal rank based on seniority value (highest = rank 1)
      const byScore = rows.slice().sort((a, b) => {
        if (b.seniority_rank !== a.seniority_rank) return b.seniority_rank - a.seniority_rank
        return (a.driver_name || '').localeCompare(b.driver_name || '')
      })
      byScore.forEach((r, i) => { r.seniority_position = r.seniority_rank > 0 ? i + 1 : null })

      rows.sort((a, b) => {
        const aPos = a.seniority_position || 999999
        const bPos = b.seniority_position || 999999
        if (aPos !== bPos) {
          return this.sortBySeniority ? aPos - bPos : bPos - aPos
        }
        return (a.driver_name || '').localeCompare(b.driver_name || '')
      })

      return rows
    },
    driverGroups() {
      let rows = this.driverRows
      if (this.selected_base) {
        rows = rows.filter(r => r.company_location && r.company_location.indexOf(this.selected_base) !== -1)
      }
      if (this.hideNoBids) {
        rows = rows.filter(r => r.allBids && r.allBids.length > 0)
      }
      const groups = [
        { key: 'full', label: 'Full Time', rows: [] },
        { key: 'part', label: 'Part Time', rows: [] },
        { key: 'casual', label: 'Casual', rows: [] },
        { key: 'other', label: 'Other', rows: [] }
      ]
      const groupMap = { full: 0, part: 1, casual: 2 }
      rows.forEach(r => {
        const status = (r.employment_status || '').toLowerCase()
        const idx = groupMap[status] != null ? groupMap[status] : 3
        groups[idx].rows.push(r)
      })
      return groups.filter(g => g.rows.length > 0)
    },
    filteredDriverCount() {
      return this.driverGroups.reduce((sum, g) => sum + g.rows.length, 0)
    },
    sortedBidsList() {
      const list = (this.bidsList || []).slice()

      list.sort((a, b) => {
        const bookingA = (a.booking_id || '').toString()
        const bookingB = (b.booking_id || '').toString()
        if (bookingA < bookingB) return -1
        if (bookingA > bookingB) return 1

        const rawOrderA = a.bid_order !== undefined && a.bid_order !== null ? String(a.bid_order).trim() : ''
        const rawOrderB = b.bid_order !== undefined && b.bid_order !== null ? String(b.bid_order).trim() : ''

        const numA = parseInt(rawOrderA, 10)
        const numB = parseInt(rawOrderB, 10)
        const aIsNum = !isNaN(numA)
        const bIsNum = !isNaN(numB)

        if (aIsNum && bIsNum && numA !== numB) {
          return numA - numB
        }
        if (rawOrderA < rawOrderB) return -1
        if (rawOrderA > rawOrderB) return 1

        const nameA = (a.driver_name || '').toString().toLowerCase()
        const nameB = (b.driver_name || '').toString().toLowerCase()
        if (nameA < nameB) return -1
        if (nameA > nameB) return 1

        return 0
      })

      return list
    },
    bidsFieldsNoAction() {
      return (this.bidsFields || []).filter((f) => f.key !== 'action')
    },
    bidsGroupedByBookingId() {
      const list = this.sortedBidsList || []
      const byBooking = new Map()
      list.forEach((bid) => {
        const key = (bid.booking_id || '').toString()
        if (!byBooking.has(key)) byBooking.set(key, [])
        byBooking.get(key).push(bid)
      })
      return Array.from(byBooking.entries()).map(([booking_id, bids]) => ({ booking_id, bids }))
    },
    visibleFields() {
      var custom_fields = null;

      if (this.summary && this.summary.visible_fields)
        custom_fields = this.summary.visible_fields;

      if (custom_fields != null) {
        let new_fields = []
        for (let visible_field of custom_fields.split(",")) {
          let found_field = this.fields_all.filter(field => visible_field == field.key)
          if (found_field.length > 0) {
            new_fields.push(found_field[0]);
          }
        }
        return new_fields;
      } else
        return this.fields.filter(field => field.visible)
    },
    set_tenant_id(id) {
      this.user.tenant = id
      localStorage.setItem('selected_tenant',id)
    },

  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      this.details_toDate = target_from_date
    },
    details_toDate(target_to_date) {
      this.details_toDate = target_to_date
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY'))
        this.details_toDate = this.details_fromDate

      const days = moment(this.details_toDate, 'MM-DD-YYYY').diff(moment(this.details_fromDate, 'MM-DD-YYYY'),'days')
      if (days > 7) {
        alert("please limit tag based date range to 1 week or less")
        this.details_fromDate = justDate(moment(this.details_toDate, 'MM-DD-YYYY').subtract(1, 'week'))
      }
    },
    selected_base() {
      this.filter_results()
    }
  },
}
</script>

<style scoped>

::v-deep tr.rowgray td { background-color: #ffffff; }
::v-deep tr.rowgray-dark td { background-color: #f2f2f2; }
::v-deep tr.rowgreen td { background-color: #e6ffed; }
::v-deep tr.rowred td { background-color: #ffecec; }
::v-deep tr.rowblue td { background-color: #9ac2ff; }
::v-deep tr.rowyellow td { background-color: #c9a227; }

.driver-bid-table-wrapper {
  overflow-x: auto;
}


.driver-bid-table {
  border-collapse: collapse;
  width: 100%;
  font-size: 13px;
}

.driver-bid-table th,
.driver-bid-table td {
  border: 1px solid #999;
  padding: 4px 6px;
  text-align: center;
  white-space: nowrap;
}

.driver-bid-table .main-header-row th {
  background-color: #b71c1c;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
}

.driver-bid-table .sub-header-row th {
  background-color: #c62828;
  color: #fff;
  font-size: 11px;
  font-weight: bold;
}

.col-seniority {
  width: 40px;
  min-width: 40px;
  font-weight: bold;
}


.col-operator {
  width: 200px;
  min-width: 200px;
  text-align: left !important;
  font-weight: bold;
  position: sticky;
  left: 0;
  z-index: 1;
}

.driver-bid-table thead .col-operator,
.driver-bid-table thead .col-seniority {
  z-index: 2;
}

.group-separator-row td {
  background-color: #333 !important;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  text-align: left !important;
  padding: 6px 12px !important;
}

.col-avail {
  width: 45px;
  min-width: 45px;
  font-weight: bold;
}

.col-bid-group {
  min-width: 70px;
}

.col-bid-val {
  font-size: 12px;
}

.driver-row {
  cursor: pointer;
}

.driver-row.row-even td {
  background-color: #ffffff;
}

.driver-row.row-odd td {
  background-color: #f2f2f2;
}

.driver-row.row-even td.col-operator {
  background-color: #ffffff;
}

.driver-row.row-odd td.col-operator {
  background-color: #f2f2f2;
}

.driver-row:hover td {
  background-color: #e3f2fd !important;
}

.bid-active {
  background-color: #e6ffed !important;
}

.bid-won {
  background-color: #9ac2ff !important;
}

.bid-other-award {
  background-color: #c9a227 !important;
}

.empty-bid {
}

.key-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.key-swatch {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 1px solid #999;
  border-radius: 2px;
}
</style>

